import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router'
import { every } from 'lodash'
import { Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

import { ClinicService } from '../services'

@Injectable({
  providedIn: 'root',
})
export class ClinicModulesGuard {

  constructor(
    private clinicService: ClinicService,
    private router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.clinicService.changes.pipe(
      map((clinic) => {
        if (clinic) {
          if (!route.data?.modules) {
            return true
          }

          if (every(route.data.modules, (clinicModule) => clinic.modules[clinicModule])) {
            return true
          }

          return this.router.createUrlTree(['/'])
        }

        return false
      }),
      catchError(() => of(false)),
    )
  }
}
